const ModalStepper = ({ steps, currentStep = 1 }) => {
  return (
    <div className="w-full px-6 py-4 font-outfit sm:px-12">
      <div className="flex items-start">
        {steps.map((step, index) => {
          const isCompleted = step.id < currentStep;
          const isActive = step.id === currentStep;
          const isReached = step.id <= currentStep;
          const isLast = index === steps.length - 1;

          return (
            <div
              key={step.id}
              className={`relative flex ${
                isLast ? "flex-none" : "flex-1"
              } flex-col items-start`}
            >
              {/* Circle + Connector */}
              <div className="relative flex w-full items-center">
                {/* Circle */}
                <div
                  className={`
                    relative z-10 flex h-6 w-6 items-center justify-center rounded-full
                    text-xs font-semibold text-white
                    transition-all duration-500 ease-out
                    ${
                      isReached
                        ? "scale-100 bg-[#4AB932] shadow-[0_0_0_4px_rgba(74,185,50,.15)]"
                        : "scale-95 bg-[#BDBDBD]"
                    }
                    ${isActive ? "animate-step-pulse" : ""}
                  `}
                >
                  {step.id}
                </div>

                {/* Connector */}
                {!isLast && (
                  <div className="relative h-px flex-1 overflow-hidden bg-[#BDBDBD]/40">
                    {/* Filled Line */}
                    <div
                      className={`
                        absolute inset-y-0 left-0 bg-[#4AB932]
                        transition-all duration-500 ease-out
                        ${isCompleted ? "w-full scale-x-100" : isActive ? "w-0 scale-x-0" : "w-0"}
                      `}
                    />

                    {/* Dashed Active Line */}
                    {isActive && (
                      <div className="absolute inset-0 border-t border-dashed border-[#BDBDBD] animate-dash" />
                    )}
                  </div>
                )}
              </div>

              {/* Label */}
              <p
                className={`
                  mt-3 text-center text-sm font-medium leading-5
                  transition-colors duration-300 -ml-6
                  ${
                    isReached
                      ? "text-text-primary"
                      : "text-text-secondary"
                  }
                `}
              >
                {step.label}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ModalStepper;